import React , {useEffect} from 'react'
import Navbar from '../component/Navbar';
import Hero from '../component/Hero';
import image1 from '../assets/photo4.jpg';
import Fotter from '../component/Fotter';
import logo from '../assets/logo.jpg';
import present from '../assets/present.jpg';
const Home = () => {
  useEffect(() => {
    document.title = 'AN-TECH - HOME'; // Change the title as desired
    // Make sure to replace 'Your Website Name' with your actual website name
  }, []);
  return (
    <>
    <Navbar/>
    <Hero 
    backgroundImage={image1}
    headingText="AN-TECH"
    paraText="Turn your bussines idea into reality with us."
    buttonText="Discord"
    />
  
  <section class="text-gray-400 bg-gray-900 body-font">
  <div class="container px-5 py-20 mx-auto flex flex-wrap">
    <div class="flex flex-wrap -mx-4 mt-auto mb-auto lg:w-1/2 sm:w-2/3 content-start sm:pr-10">
      <div class="w-full sm:p-4 px-4 mb-6">
        <h1 class="title-font font-medium text-xl mb-2 text-white">welcome to AN-TECH where you can convert your dream bussines into reality.</h1>
        <div class="leading-relaxed">Unlocking Digital Creativity: AN-TECH - Where Web Development, Graphics Designing, Video Editing, and Product Promotion Converge.</div>
      </div>
      <div class="p-4 sm:w-1/2 lg:w-1/4 w-1/2">
        <h2 class="title-font font-medium text-3xl text-white">5+</h2>
        <p class="leading-relaxed">product promoted</p>
      </div>
      <div class="p-4 sm:w-1/2 lg:w-1/4 w-1/2">
        <h2 class="title-font font-medium text-3xl text-white">5+</h2>
        <p class="leading-relaxed">Website maked</p>
      </div>
      <div class="p-4 sm:w-1/2 lg:w-1/4 w-1/2">
        <h2 class="title-font font-medium text-3xl text-white">300+</h2>
        <p class="leading-relaxed">Graphics designing product maked</p>
      </div>
      <div class="p-4 sm:w-1/2 lg:w-1/4 w-1/2">
        <h2 class="title-font font-medium text-3xl text-white">50+</h2>
        <p class="leading-relaxed">Video edited</p>
      </div>
    </div>
    <div class="lg:w-1/2 sm:w-1/3 w-full rounded-lg overflow-hidden mt-6 sm:mt-0">
      <img class="object-cover object-center w-full h-full" src={present} alt="stats"/>
    </div>
  </div>
</section>
<section class="mb-20 text-white body-font bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 mx-auto">
  <div class="container px-5 py-5 mx-auto">
    <div class="lg:w-2/3 flex flex-col sm:flex-row sm:items-center items-start mx-auto">
      <div class="flex-grow sm:pr-16">
        <img src={logo} alt="Image Description" class="w-48 h-auto rounded-md shadow-md" />
      </div>
      <div class="flex-grow sm:pl-16 pt-8 sm:pt-0">
        <h1 class="text-4xl font-bold title-font mb-4">Join our Discord server for Help🔎 and fun🚀😃.</h1>
        <p class="text-lg mb-6 font-rajdhani">Connect with our vibrant community to get help and have fun together.</p>

        <a href="https://discord.gg/5x6AgqQe" class="inline-flex items-center justify-center px-6 py-3 bg-orange-500 border-0 focus:outline-none hover:bg-white-600 rounded text-xl">
          Join our Discord
        </a>
      </div>
    </div>
  </div>
</section>

    <Fotter/>
    </>
  )
}

export default Home